import React from 'react';
import { Link } from 'react-router-dom';

class TsLogo extends React.Component {
	render () {
		return (
			<div className="m-auto txtcenter">
				<Link to="/">
					<img src="/static/images/Ts-logo.png" 
						className="tsLogo mtm" />
				</Link>
			</div>
		);
	}
}

export default TsLogo;


// WEBPACK FOOTER //
// ./src/js/TsLogo.jsx